module.exports = __webpack_public_path__ + "media/images/sad-72b355e09a3290584e051ad697deb512.svg";